import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ea81210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-record-skin-bg" }
const _hoisted_2 = { class: "my-record-skin-bg-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-record-skin-bg-mask" }, null, -1))
const _hoisted_4 = { class: "my-record-skin-bg-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "my-record-list-container" }
const _hoisted_7 = { class: "my-record-info" }
const _hoisted_8 = { class: "my-record-skin-logo-container" }
const _hoisted_9 = { class: "my-record-skin-logo" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "my-record-info-container" }
const _hoisted_12 = { class: "my-record-title" }
const _hoisted_13 = { class: "my-record-info-other" }
const _hoisted_14 = {
  key: 0,
  class: "text-opacity"
}
const _hoisted_15 = { class: "text-opacity" }
const _hoisted_16 = { class: "my-record-other" }
const _hoisted_17 = { class: "amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_personality_button = _resolveComponent("personality-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "my-record-list",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.routeViewRecords && _ctx.routeViewRecords(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: `${_ctx.publicPath}skin/${_ctx.data.type}.jpg`,
            alt: ""
          }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: `${_ctx.publicPath}skin/${_ctx.data.type}.jpg`,
              alt: ""
            }, null, 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.data.title), 1),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.data.sender)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$checkI18n("redPackFrom", {
                  address: _ctx.$tools.captureAddress(_ctx.data.sender),
                })), 1))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass([_ctx.isReceiveExpired ? 'expired' : 'text-opacity'])
                }, _toDisplayString(_ctx.isReceiveFinish(_ctx.data.count, _ctx.data.receivedCount)
                  ? _ctx.$checkI18n("records.status.finish")
                  : _ctx.isReceiveExpired
                  ? _ctx.$checkI18n("records.status.expired")
                  : _ctx.$checkI18n("records.status.progress")), 3)),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$tools.timeFormat(_ctx.data.receiveDate || _ctx.data.sendDate)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.data.sender && "+") + " " + _toDisplayString(_ctx.$tools.amountFormat(_ctx.data.amount, _ctx.data.decimal)) + " " + _toDisplayString(_ctx.data.denom), 1),
        (Number(_ctx.data.expiredAmount) > 0)
          ? (_openBlock(), _createBlock(_component_personality_button, {
              key: 0,
              class: "refund-btn",
              type: "form",
              loadingTheme: "dark",
              loading: _ctx.refundLoading,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.refundRedPack(_ctx.data.envelopeId)), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$checkI18n("records.refund", {
                amount: `${_ctx.$tools.amountFormat(
                  _ctx.data.expiredAmount,
                  _ctx.data.decimal
                )} ${_ctx.data.denom}`,
              })), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}